export default __webpack_public_path__ + "static/media/vodacom-c3d.150a3575.png";